// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"573":"b4f4eedf","741":"88d428e7","865":"48b091a4"}[chunkId] + ".css";
};